import React from 'react';
import { Link } from 'react-router-dom';

export const Logo = ({ isWhite = false }) => {
  return (
    <Link to="/" className="flex items-center">
      <img 
        src={isWhite ? "/images/Logo.png" : "/images/Logo.png"} 
        alt="ECOSOFT Logo" 
        className="h-8 w-auto"
      />
      <span className={`ml-4 text-2xl font-bold ${isWhite ? 'text-white' : 'text-[#0066CC]'}`}>ECOSOFT</span>
    </Link>
  );
}; 